//
//
//
//

import StoreFinder from "@/components/pages/storeFinder/index";
import staticPagesLang from "~/mixins/staticPagesLang";

export default {
    name: "StoreFinderPage",
    components: {StoreFinder},
    head() {
        return {
            script: [
                {src: `https://maps.googleapis.com/maps/api/js?key=AIzaSyD0xiKdDoXguLAIboFgj4ni4_Dg9sSi90s&libraries=places&language=uk`},
            ]
        }
    },
    mixins: [
        staticPagesLang
    ],
}
